<template>
  <div
    v-if="count || initCount"
    :class="[
      counterSelector,
      {
        'favorite-products-counter_hidden': initCount && count === 0,
      },
    ]"
  >
    {{ count ? count : initCount }}
  </div>
</template>

<script>
export default {
  name: 'favorite-products-counter',
  computed: {
    ...Vuex.mapState('favoriteProducts', ['count']),
  },
  props: {
    initCount: String,
    counterSelector: String,
  },
};
</script>
